import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { DefaultButton, PrimaryButton } from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import { RAISED_DEFAULT_BUTTONS, RAISED_DEFAULT_BUTTONS_LIST } from "../../../../Data/Buttons/RaisedStyle";
import CommonRaisedButton from "../Common/CommonRaisedButton";

const RaisedDefaultButtons = () => {
  const [buttonTooltip, setButttooltip] = useState(false);
  const buttonToggle = () => setButttooltip(!buttonTooltip);
  return (
    <Card>
      <CommonCardHeader title={DefaultButton} span={RAISED_DEFAULT_BUTTONS} />
      <CardBody className="btn-showcase">
        <Btn color="primary" className="btn-pill btn-air-primary" id="Tooltip-1">{PrimaryButton}</Btn>
        <ToolTip target="Tooltip-1" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-pill btn-primary btn-air-primary</ToolTip>
        {RAISED_DEFAULT_BUTTONS_LIST.map((data, index) => (
          <CommonRaisedButton key={index} item={data} />
        ))}
      </CardBody>
    </Card>
  );
};

export default RaisedDefaultButtons;
